import { ReactNode } from 'react';

interface IProps {
  children?: ReactNode | ReactNode[];
}

export const ModalFooter = (props: IProps) => (
  <div className="bg-lake-fog rounded-b-md p-6" {...props} />
);
